import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card mb-4" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Consulta de Pacientes", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-secondary dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Acciones ", -1)
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bed-pulse" }, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-gears" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exchange-alt" }, null, -1)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-door-open" }, null, -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "nombreHabitacion",
  class: "form-label"
}, "Nombre de la habitación: *", -1)
const _hoisted_25 = {
  key: 0,
  class: "p-error"
}
const _hoisted_26 = {
  key: 0,
  class: "row"
}
const _hoisted_27 = { class: "col-12 mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", null, "Paciente:", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "Habitación actual:", -1)
const _hoisted_30 = { class: "col-12 mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "habitacionDestino",
  class: "form-label"
}, "Seleccionar habitación destino:", -1)
const _hoisted_32 = {
  key: 0,
  class: "col-12"
}

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Message = _resolveComponent("Message")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.profileLvl == 5)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Crear Habitación",
                    icon: "pi pi-plus",
                    severity: "success",
                    onClick: _ctx.abrirModalCrearHabitacion
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DataTable, {
              value: _ctx.habitaciones,
              stripedRows: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "habitacion",
                  header: "Habitación"
                }),
                _createVNode(_component_Column, {
                  field: "status",
                  header: "Estatus"
                }, {
                  body: _withCtx((prop) => [
                    _createTextVNode(_toDisplayString(_ctx.formatHabitacion(prop.data.status)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "nombrePaciente",
                  header: "Paciente"
                }),
                _createVNode(_component_Column, { header: "Acciones" }, {
                  body: _withCtx((prop) => [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("ul", _hoisted_10, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            title: "Ver o Editar Información del Paciente",
                            onClick: $event => (_ctx.editHabitacion(prop.data.idHabitacion))
                          }, [
                            _createTextVNode(" Información del Paciente "),
                            _hoisted_12
                          ], 8, _hoisted_11)
                        ]),
                        (_ctx.profileLvl == 5)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                              _createElementVNode("button", {
                                class: "dropdown-item",
                                title: "Ver o Editar Información de la Habitación",
                                onClick: $event => (_ctx.editExtrasHabitacion(prop.data.idHabitacion, prop.data.habitacion))
                              }, [
                                _createTextVNode(" Extras de la Habitación "),
                                _hoisted_15
                              ], 8, _hoisted_14)
                            ]))
                          : _createCommentVNode("", true),
                        (prop.data.status == 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                              _createElementVNode("button", {
                                class: "dropdown-item",
                                title: "Cambiar de Habitación",
                                onClick: $event => (_ctx.cambiarHabitacion(prop.data))
                              }, [
                                _createTextVNode(" Cambiar de Habitación "),
                                _hoisted_18
                              ], 8, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true),
                        (prop.data.status == 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                              _createElementVNode("button", {
                                class: "dropdown-item",
                                title: "Liberar la Información del Paciente",
                                onClick: $event => (_ctx.liberarHabitacion(prop.data))
                              }, [
                                _createTextVNode(" Liberar Habitación "),
                                _hoisted_21
                              ], 8, _hoisted_20)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showCrearHabitacionModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.showCrearHabitacionModal) = $event)),
      modal: "",
      header: "Nueva Habitación",
      style: { width: '35rem' },
      closable: !_ctx.crearHabitacionSubmitting,
      onHide: _ctx.cerrarModalCrearHabitacion
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancelar",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.cerrarModalCrearHabitacion,
          disabled: _ctx.crearHabitacionSubmitting
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          label: "Guardar",
          icon: "pi pi-check",
          onClick: _ctx.guardarNuevaHabitacion,
          loading: _ctx.crearHabitacionSubmitting,
          disabled: _ctx.crearHabitacionSubmitting
        }, null, 8, ["onClick", "loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_InputText, {
              id: "nombreHabitacion",
              type: "text",
              class: _normalizeClass(["form-control", { 'p-invalid': !!_ctx.crearHabitacionError }]),
              placeholder: "Ej: 101 / Urgencias 1",
              modelValue: _ctx.nuevoNombreHabitacion,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.nuevoNombreHabitacion) = $event)),
              disabled: _ctx.crearHabitacionSubmitting
            }, null, 8, ["modelValue", "disabled", "class"]),
            (_ctx.crearHabitacionError)
              ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(_ctx.crearHabitacionError), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "closable", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showCambiarHabitacionModal,
      "onUpdate:visible": _cache[3] || (_cache[3] = $event => ((_ctx.showCambiarHabitacionModal) = $event)),
      modal: "",
      header: "Cambiar de Habitación",
      style: { width: '50rem' },
      closable: true,
      onHide: _ctx.cerrarModalCambio
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancelar",
          icon: "pi pi-times",
          onClick: _ctx.cerrarModalCambio,
          class: "p-button-text"
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Confirmar Cambio",
          icon: "pi pi-check",
          onClick: _ctx.confirmarCambioHabitacion,
          disabled: !_ctx.habitacionSeleccionada || _ctx.habitacionesLibres.length === 0
        }, null, 8, ["onClick", "disabled"])
      ]),
      default: _withCtx(() => [
        (_ctx.pacienteACambiar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", null, [
                  _hoisted_28,
                  _createTextVNode(" " + _toDisplayString(_ctx.pacienteACambiar.nombrePaciente), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_29,
                  _createTextVNode(" " + _toDisplayString(_ctx.pacienteACambiar.habitacion), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_Dropdown, {
                  id: "habitacionDestino",
                  modelValue: _ctx.habitacionSeleccionada,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.habitacionSeleccionada) = $event)),
                  options: _ctx.habitacionesLibres,
                  optionLabel: "habitacion",
                  placeholder: "Seleccione una habitación libre",
                  class: "w-100",
                  filter: true,
                  filterPlaceholder: "Buscar habitación..."
                }, null, 8, ["modelValue", "options"])
              ]),
              (_ctx.habitacionesLibres.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_Message, {
                      severity: "warn",
                      closable: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" No hay habitaciones libres disponibles para el cambio. ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}